'use client';
import { useMemo, useState } from 'react';
import { HStack, VStack } from '@chakra-ui/react';

import { breakpoints } from 'app/themeConfig';
import SliderControls from 'features/SliderControls';
import SmallProjectsCasesCard from 'entities/SmallProjectsCasesCard';
import { useSwiperControls } from 'shared/hooks';
import BlockHeader from 'shared/BlockHeader';
import { arrayShuffle } from 'shared/lib';
import Slider from 'shared/Slider';

import { allProjectsCasesPagesData } from 'constants/ProjectCases';

const transformCasesData = (casesData, currentPageTitle, currentPageDomain) => {
  const allCasesData = Object.values(casesData);
  const filteredCasesByDomainAndTitle = [
    ...allCasesData.filter(
      caseData => caseData.domain === currentPageDomain && caseData.title !== currentPageTitle,
    ),
    ...arrayShuffle(allCasesData.filter(caseData => caseData.domain !== currentPageDomain)),
  ];

  return filteredCasesByDomainAndTitle.map(
    ({
      companyLogo,
      companyLogoProps,
      customIconPropsToOtherProjectsBlock,
      domain,
      illustration,
      cardScreen,
      title,
      link,
    }) => ({
      companyLogo,
      companyLogoProps: {
        ...companyLogoProps,
        boxSize: '48px',
        iconProps: customIconPropsToOtherProjectsBlock ?? { w: '60%', h: 'auto' },
      },
      domain,
      illustration,
      cardScreen,
      title,
      link,
      isCompactDesign: true,
    }),
  );
};

const OtherProjects = ({ currentPageTitle, currentPageDomain }) => {
  const [swiper, setSwiper] = useState(null);
  const controls = useSwiperControls(swiper);

  const slidesData = useMemo(
    () => transformCasesData(allProjectsCasesPagesData, currentPageTitle, currentPageDomain),
    [allProjectsCasesPagesData, currentPageTitle, currentPageDomain],
  );

  return (
    <VStack as="section" w="full" align="start" gap={{ mobile: '20px', tablet: '24px' }}>
      <HStack w="full" justify="space-between">
        <BlockHeader textStyle="header.h3">Другие проекты</BlockHeader>

        <SliderControls {...controls} />
      </HStack>

      <Slider
        controller={swiper}
        setController={setSwiper}
        SlideComponent={SmallProjectsCasesCard}
        slidesData={slidesData}
        mousewheel={false}
        lazyPreloadPrevNext={3}
        pagination={{ clickable: true, dynamicBullets: Boolean(slidesData.length > 15) }}
        breakpoints={{ [parseInt(breakpoints.xm)]: { slidesPerView: 'auto' } }}
      />
    </VStack>
  );
};

export default OtherProjects;
